import { apiSlice } from '../../app/services/apiSlice';

const COMPANY_URL = 'backoffice/companies';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: (data) => ({
        url: `${COMPANY_URL}/${data.id}/accounts`,
        params: data.params,
      }),
    }),
    getUserRoles: builder.query({
      query: (companyId) => ({
        url: `${COMPANY_URL}/accountRoles`,
        params: { companyId },
      }),
      transformResponse: (responseData) => {
        responseData?.roles?.length > 0 && responseData?.roles?.sort((a,b)=> (a?.title>b?.title)*2-1)
        responseData = responseData?.roles?.map((cat) => ({
          label: cat.name,
          value: cat.id
        }));
        return responseData || {};
      },
    }),
    addNewUser: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/${data.compId}/accounts`,
        method: 'POST',
        body: { ...data.body }
      }),
    }),
     resetUserPassword: builder.mutation({
      query: (data) => ({
        url: `/backoffice/accounts/change-password`,
        method: 'PUT',
        body:{...data}
      }),
    }),
    editNewUser: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/${data.compId}/accounts/${data?.user?.id}`,
        method: 'PUT',
        body: { ...data.body }
      }),
    }),
    deleteUser: builder.mutation({
      query: (data) => ({
        url: `${COMPANY_URL}/${data?.companyId}/accounts/${data?.id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useResetUserPasswordMutation,
  useGetAllUsersQuery,
  useGetUserRolesQuery,
  useAddNewUserMutation,
  useEditNewUserMutation,
  useDeleteUserMutation,
} = extendedApiSlice;
